import { useLayoutEffect, useId, useRef, type ReactNode } from 'react';
import { Icon } from './Icon';

/** Native modal behavior supplies focus containment and makes the background inert. */
export function Dialog({
  title,
  children,
  onClose,
  busy = false,
}: {
  title: string;
  children: ReactNode;
  onClose: () => void;
  busy?: boolean;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useLayoutEffect(() => {
    const previous = document.activeElement;
    const dialog = ref.current;
    dialog?.showModal();
    return () => {
      // Close before React removes the element so native focus restoration can finish.
      dialog?.close();
      if (previous instanceof HTMLElement) previous.focus();
    };
  }, []);
  return (
    <dialog
      className="dialog"
      ref={ref}
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        if (!busy) onClose();
      }}
    >
      <header className="card-head">
        <h2 id={titleId}>{title}</h2>
        <button
          className="btn ghost icon-btn right"
          type="button"
          aria-label="Close dialog"
          disabled={busy}
          onClick={onClose}
        >
          <Icon name="close" />
        </button>
      </header>
      <div className="card-pad stack">{children}</div>
    </dialog>
  );
}
